<h1 mat-dialog-title>Wachtwoord van een account veranderen</h1>

<div mat-dialog-content class="adjust-password">
  <form [formGroup]="userForm">
    <mat-form-field>
      <mat-label>E-mail</mat-label>
      <input formControlName="email" type="email" matInput required />
      @if (userForm.controls.email.errors?.required) {
        <mat-error>Vul dit veld in.</mat-error>
      }
      @if (userForm.controls.email.errors?.email) {
        <mat-error>E-mailadres is ongeldig.</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Wachtwoord</mat-label>
      <input formControlName="password" matInput required />
      @if (userForm.controls.password.errors?.required) {
        <mat-error>Vul dit veld in.</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Wachtwoord bevestigen</mat-label>
      <input formControlName="passwordVerification" matInput required />
      @if (userForm.controls.passwordVerification.errors?.required) {
        <mat-error>Vul dit veld in.</mat-error>
      }
      @if (userForm.controls.passwordVerification.errors?.customError) {
        <mat-error>De wachtwoorden komen niet overeen.</mat-error>
      }
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Annuleren</button>
  <button
    [class.spinner]="saving()"
    mat-flat-button
    [disabled]="!userForm.valid || saving()"
    (click)="save()"
    cdkFocusInitial
  >
    Opslaan
  </button>
</div>
